import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration

export default class tableView extends JetView {
    // Defining the tableView class extending JetView
    config() {
        // Method to define the configuration of the view
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date format configuration
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Retrieving partner ID from parameters

        return {
            // Returning the configuration object
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // Defining a datatable view
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                // Defining columns for the datatable
                                {
                                    id: 'edit', // Column ID for edit action
                                    header: '', // Header for the column
                                    width: 50, // Width of the column
                                    height: 25, // Height of the column
                                    template: function (obj) {
                                        // Template function for rendering edit icon
                                        if (!devConfig.getPermAction('TemplateEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Return close icon if no permission
                                        } else {
                                            return ''; // Return empty if permission exists
                                        }
                                    },
                                },
                                {
                                    id: 'detailTittle', // Column ID for detail action
                                    header: '', // Header for the column
                                    width: 50, // Width of the column
                                    height: 25, // Height of the column
                                    tooltip: _('Detalles'), // Tooltip for the column
                                    template: function (obj) {
                                        // Template function for rendering detail icon
                                        return "<span class='webix_icon wxi-close details'></span>"; // Return detail icon
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for ID
                                    header: _('ID'), // Header for the column with localization
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Column ID for Type
                                    header: _('Tipo'), // Header for the column with localization
                                    width: 200, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Language', // Column ID for Language
                                    header: _('Idioma'), // Header for the column with localization
                                    width: 200, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Section', // Column ID for Section
                                    header: _('Sección'), // Header for the column with localization
                                    width: 200, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handlers for click events
                                details: function (euv, id) {
                                    // Handler for detail icon click
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.show(
                                        '../partner.templates.pdfTemplate?id=' + item.Id, // Show detail view with item ID
                                    );
                                },
                                edit: function (euv, id) {
                                    // Handler for edit icon click
                                    var item = this.getItem(id); // Get the clicked item
                                    $$('editTemplate').show(); // Show edit template
                                    $$('editform').setValues(item); // Set values in the edit form
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            autoConfig: false, // Disable automatic column configuration
                            pager: 'pagerA', // Pager ID for pagination
                            on: {
                                // Event handlers for datatable events
                                onItemDblClick: (id) => {}, // Double click event handler (empty)
                                onBeforeLoad: function () {
                                    // Before load event handler
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // After load event handler
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // Ready event handler
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay box
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                        },
                    ],
                },
            ],
        };
    }
    init(grid) {
        // Initialization method
        grid = $$('datatable'); // Get the datatable instance
        const _ = this.app.getService('locale')._; // Localization service for translations
        var vthis = this; // Reference to the current instance
        var url = devConfig.geturlApi() + 'Partners/GetTemplatePDFList'; // API URL for fetching templates
        var filter = ''; // Filter string for API requests
        grid.showOverlay(
            // Show no data overlay
            "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
        );
        const id_partner = this.getParam('partner', true); // Retrieve partner ID from parameters
        this.on(this.app, 'filter', (filterData) => {
            // Event listener for filter changes
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object and non-empty values
                    if (object[i][0] == 'Datepicker') {
                        // Check for datepicker filter
                        if (object[i][1] !== ' ') {
                            // Check if date is not empty
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                            string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                        }
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check for object type filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Check for start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Check for end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(
                // Load data from API with filters
                url + '?start=0&count=' + grid.data.$pagesize + string1,
            ).then(function (data) {
                // Handle the response
                data = data.json(); // Parse JSON response
                if (!data.HasError) {
                    // Check for errors in response
                    if (data.Data.length > 0) {
                        // Check if data is available
                        this.hideOverlay(); // Hide no data overlay
                    } else {
                        grid.clearAll(); // Clear grid if no data
                        grid.showOverlay(
                            // Show no data overlay
                            "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                        );
                    }
                } else {
                    grid.clearAll(); // Clear grid on error
                    grid.showOverlay(
                        // Show no data overlay
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                    );
                    webix.message({
                        // Show error message
                        title: _('¡Error!'),
                        type: 'alert-error',
                        text: _('Ocurrio un error, comuniquese con soporte'),
                    });
                }
            });
            filter = string1; // Update filter variable
        });
        var datePopup = []; // Array to hold date options for popup
        var popup = ''; // Variable for add popup
        var popupAdd = ''; // Variable for edit popup
        const params = {
            // Parameters for API request
            Partner: id_partner, // Partner ID
        };
        webix // AJAX request to fetch section templates
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(
                devConfig.geturlApi() + 'Partners/GetSectionTemplatePDFSelect', // API endpoint
                params, // Request parameters
                {
                    error: function (text, data, XmlHttpRequest) {
                        // Error handler
                        webix.message('Error! '); // Show error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        // Success handler
                        var resp = JSON.parse(text); // Parse response
                        if (!resp.HasError) {
                            // Check for errors
                            datePopup = resp.Data; // Store date options
                            popupAdd = webix.ui({
                                // Create add template popup
                                view: 'window',
                                id: 'AddProviders',
                                width: screen.width < 500 ? 350 : 450, // Set width based on screen size
                                height: screen.width < 500 ? 600 : 250, // Set height based on screen size
                                fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
                                head: {
                                    // Header configuration
                                    view: 'toolbar',
                                    cols: [
                                        {
                                            view: 'label',
                                            label: _('Añadir Plantilla'), // Label for add template
                                        },
                                        {
                                            view: 'icon',
                                            icon: 'wxi-close', // Close icon
                                            click: function () {
                                                // Close button click handler
                                                this.getTopParentView().hide(); // Hide the popup
                                            },
                                        },
                                    ],
                                },
                                position: 'center', // Center position for the popup
                                modal: true, // Modal popup
                                body: {
                                    // Body configuration
                                    view: 'scrollview',
                                    scroll: 'y', // Enable vertical scrolling
                                    body: {
                                        view: 'form', // Form for adding template
                                        id: 'addform', // Form ID
                                        width: screen.width < 500 ? 350 : 450, // Set width based on screen size
                                        height: screen.width < 500 ? 600 : 200, // Set height based on screen size
                                        elements: [
                                            // Form elements
                                            {
                                                view: 'text',
                                                label: _('Tipo'), // Label for Type
                                                name: 'Type', // Input name
                                                required: true, // Required field
                                                labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                                                labelWidth: 150, // Label width
                                            },
                                            {
                                                view: 'combo', // Combo box for Language
                                                label: _('Idioma'), // Label for Language
                                                name: 'Language', // Input name
                                                required: true, // Required field
                                                labelWidth: 150, // Label width
                                                options: [
                                                    // Options for the combo box
                                                    {
                                                        id: 'es',
                                                        value: 'español (o castellano) (ES)', // Spanish option
                                                    },
                                                    {
                                                        id: 'en',
                                                        value: 'English (EN)', // English option
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'combo', // Combo box for Section
                                                label: _('Sección'), // Label for Section
                                                name: 'Section', // Input name
                                                options: datePopup, // Options from API response
                                                required: true, // Required field
                                                labelWidth: 150, // Label width
                                            },
                                            {
                                                cols: [
                                                    // Button row
                                                    {
                                                        view: 'button',
                                                        value: _('Cancelar'), // Cancel button
                                                        click: function () {
                                                            // Cancel button click handler
                                                            this.getTopParentView().hide(); // Hide the popup
                                                            $$('addform').setValues(
                                                                $$('addform').getCleanValues(), // Reset form values
                                                            );
                                                        },
                                                    },
                                                    {
                                                        view: 'button',
                                                        type: 'form', // Button type
                                                        value: _('Guardar'), // Save button
                                                        click: function ($e) {
                                                            // Save button click handler
                                                            var values = $$('addform').getValues(); // Get form values
                                                            values.Partner = id_partner; // Add partner ID to values
                                                            if (
                                                                $$('addform').validate() // Validate form
                                                            ) {
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'Partners/AddTemplatePDFList', // API endpoint for adding template
                                                                        values, // Request values
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                // Error handler
                                                                                webix.message({
                                                                                    title: _(
                                                                                        '¡Error!', // Error title
                                                                                    ),
                                                                                    type: 'alert-error', // Error type
                                                                                    text: _(
                                                                                        'Ocurrio un error, comuniquese con soporte', // Error message
                                                                                    ),
                                                                                });
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                // Success handler
                                                                                var response = JSON.parse(
                                                                                    text, // Parse response
                                                                                );
                                                                                if (
                                                                                    !response.HasError // Check for errors
                                                                                ) {
                                                                                    webix.message(
                                                                                        'Tipo de plantilla agregada satisfactoriamente.', // Success message
                                                                                    );
                                                                                    grid.clearAll(); // Clear grid
                                                                                    grid.load(
                                                                                        url +
                                                                                            '?start=0&count=' +
                                                                                            grid.data.$pagesize +
                                                                                            filter, // Reload grid data
                                                                                    );
                                                                                } else {
                                                                                    webix.message({
                                                                                        title: _(
                                                                                            '¡Error!', // Error title
                                                                                        ),
                                                                                        type: 'alert-error', // Error type
                                                                                        text: _(
                                                                                            'Ocurrio un error, comuniquese con soporte', // Error message
                                                                                        ),
                                                                                    });
                                                                                }
                                                                            },
                                                                        },
                                                                    );
                                                                $$('addform').setValues(
                                                                    $$('addform').getCleanValues(), // Reset form values
                                                                );
                                                                this.getTopParentView().hide(); // Hide the popup
                                                            } else {
                                                                webix.message({
                                                                    title: _(
                                                                        '¡Error!', // Error title
                                                                    ),
                                                                    type: 'alert-error', // Error type
                                                                    text: _(
                                                                        'Completa los campos...', // Error message
                                                                    ),
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                        elementsConfig: {
                                            // Configuration for form elements
                                            on: {
                                                onChange: function () {
                                                    // Change event handler
                                                    this.validate(); // Validate on change
                                                },
                                            },
                                        },
                                    },
                                },
                            });
                            popup = webix.ui({
                                // Create edit template popup
                                view: 'window',
                                id: 'editTemplate',
                                width: screen.width < 500 ? 350 : 450, // Set width based on screen size
                                height: screen.width < 500 ? 600 : 350, // Set height based on screen size
                                fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
                                head: {
                                    // Header configuration
                                    view: 'toolbar',
                                    cols: [
                                        {
                                            view: 'label',
                                            label: _('Editar Plantilla'), // Label for edit template
                                        },
                                        {
                                            view: 'icon',
                                            icon: 'wxi-close', // Close icon
                                            click: function () {
                                                // Close button click handler
                                                this.getTopParentView().hide(); // Hide the popup
                                            },
                                        },
                                    ],
                                },
                                position: 'center', // Center position for the popup
                                modal: true, // Modal popup
                                body: {
                                    // Body configuration
                                    view: 'scrollview',
                                    scroll: 'y', // Enable vertical scrolling
                                    body: {
                                        view: 'form', // Form for editing template
                                        id: 'editform', // Form ID
                                        width: screen.width < 500 ? 350 : 450, // Set width based on screen size
                                        height: screen.width < 500 ? 600 : 250, // Set height based on screen size
                                        elements: [
                                            // Form elements
                                            {
                                                view: 'text',
                                                label: 'Id', // Label for ID
                                                name: 'Id', // Input name
                                                readonly: true, // Readonly field
                                                required: true, // Required field
                                                labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                                                labelWidth: 150, // Label width
                                            },
                                            {
                                                view: 'text',
                                                label: _('Tipo'), // Label for Type
                                                name: 'Type', // Input name
                                                readonly: false, // Editable field
                                                required: true, // Required field
                                                labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                                                labelWidth: 150, // Label width
                                            },
                                            {
                                                view: 'combo', // Combo box for Language
                                                label: _('Idioma'), // Label for Language
                                                name: 'Language', // Input name
                                                required: true, // Required field
                                                labelWidth: 150, // Label width
                                                options: [
                                                    // Options for the combo box
                                                    {
                                                        id: 'es',
                                                        value: 'español (o castellano) (ES)', // Spanish option
                                                    },
                                                    {
                                                        id: 'en',
                                                        value: 'English (EN)', // English option
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'combo', // Combo box for Section
                                                label: _('Sección'), // Label for Section
                                                name: 'Section', // Input name
                                                options: datePopup, // Options from API response
                                                required: true, // Required field
                                                labelWidth: 150, // Label width
                                            },
                                            {
                                                cols: [
                                                    // Button row
                                                    {
                                                        view: 'button',
                                                        value: _('Cancelar'), // Cancel button
                                                        click: function () {
                                                            // Cancel button click handler
                                                            this.getTopParentView().hide(); // Hide the popup
                                                        },
                                                    },
                                                    {
                                                        view: 'button',
                                                        type: 'form', // Button type
                                                        value: _('Guardar'), // Save button
                                                        click: function ($e) {
                                                            // Save button click handler
                                                            var values = $$('editform').getValues(); // Get form values
                                                            values.Partner = id_partner; // Add partner ID to values
                                                            if (
                                                                $$('editform').validate() // Validate form
                                                            ) {
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'Partners/UpdateTemplatePDFList', // API endpoint for updating template
                                                                        values, // Request values
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                // Error handler
                                                                                webix.message({
                                                                                    title: _(
                                                                                        '¡Error!', // Error title
                                                                                    ),
                                                                                    type: 'alert-error', // Error type
                                                                                    text: _(
                                                                                        'Ocurrio un error, comuniquese con soporte', // Error message
                                                                                    ),
                                                                                });
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                // Success handler
                                                                                var response = JSON.parse(
                                                                                    text, // Parse response
                                                                                );
                                                                                if (
                                                                                    !response.HasError // Check for errors
                                                                                ) {
                                                                                    webix.message(
                                                                                        'Tipo de plantilla actualizada satisfactoriamente.', // Success message
                                                                                    );
                                                                                    grid.clearAll(); // Clear grid
                                                                                    grid.load(
                                                                                        url +
                                                                                            '?start=0&count=' +
                                                                                            grid.data.$pagesize +
                                                                                            filter, // Reload grid data
                                                                                    );
                                                                                } else {
                                                                                    webix.message({
                                                                                        title: _(
                                                                                            '¡Error!', // Error title
                                                                                        ),
                                                                                        type: 'alert-error', // Error type
                                                                                        text: _(
                                                                                            'Ocurrio un error, comuniquese con soporte', // Error message
                                                                                        ),
                                                                                    });
                                                                                }
                                                                            },
                                                                        },
                                                                    );
                                                                $$('editform').setValues(
                                                                    $$('editform').getCleanValues(), // Reset form values
                                                                );
                                                                this.getTopParentView().hide(); // Hide the popup
                                                            } else {
                                                                webix.message({
                                                                    title: _(
                                                                        '¡Error!', // Error title
                                                                    ),
                                                                    type: 'alert-error', // Error type
                                                                    text: _(
                                                                        'Completa los campos...', // Error message
                                                                    ),
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                        elementsConfig: {
                                            // Configuration for form elements
                                            on: {
                                                onChange: function () {
                                                    // Change event handler
                                                    this.validate(); // Validate on change
                                                },
                                            },
                                        },
                                    },
                                },
                            });
                        }
                    },
                },
            );
        this.on(this.app, 'addTemplate:button', (filter) => {
            // Event listener for add template button
            if (datePopup.length > 0) {
                // Check if date options are available
                $$('addform').clearValidation(); // Clear validation
                popupAdd.show(); // Show add template popup
            } else {
                webix.message({
                    // Show error message if no data
                    text: _('Datos no han podido ser cargados'), // Error message
                    title: _('¡Error!'), // Error title
                    type: 'alert-error', // Error type
                });
            }
        });
    }
}

// FILE DOCUMENTED
